var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"to-top",on:{"click":function($event){return _vm.toTop()}}},[_c('SvgIcon',{attrs:{"icon-class":"to-top"}}),_vm._v(" "),_c('span',[_vm._v("顶部")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1965040c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/layout/ToTop.vue
// module id = null
// module chunks = 